import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteTelematicsBox() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => {
      if (id) {
        return api.delete(`telematicsBoxes/${id}`);
      }
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['telematicsBoxes'] }),
  });
}
